var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRgtarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 62,
    viewBox: "0 0 91 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7071 31.7071C66.0976 31.3166 66.0976 30.6834 65.7071 30.2929L59.3431 23.9289C58.9526 23.5384 58.3195 23.5384 57.9289 23.9289C57.5384 24.3195 57.5384 24.9526 57.9289 25.3431L63.5858 31L57.9289 36.6569C57.5384 37.0474 57.5384 37.6805 57.9289 38.0711C58.3195 38.4616 58.9526 38.4616 59.3431 38.0711L65.7071 31.7071ZM23 32H65V30H23V32Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 90,
    height: 61,
    stroke: "black",
    strokeOpacity: 0.37
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRgtarrow);
export default __webpack_public_path__ + "static/media/rgtarrow.b16abb5b113c275882d86fe8dd7adcf1.svg";
export { ForwardRef as ReactComponent };